import { LaiSuatText } from "constants/choVayConst";
import React, { useState, useEffect, useRef, forwardRef } from "react";
import { formatNumber, nFormatter, formatMoney } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
class ThuChiHopDongPrint extends React.Component {
  renderTableData() {
    if (typeof this.props.dataPrint.List != "undefined") {
      return this.props.dataPrint.List.map((item, i) => {
        let laisatText = "";
        return (
          <tr>
            <td
              style={{
                border: "1px solid #EEE",
                padding: "5px",
                textAlign: "center",
              }}
            >
              <div>{i + 1}</div>
            </td>
            <td style={{ border: "1px solid #EEE", padding: "5px" }}>
              {item.Code}
              <br />
              <div>
                ({getDate(item.NgayVay)} - {getDate(item.NgayTra)})
              </div>
            </td>
            <td style={{ border: "1px solid #EEE", padding: "5px" }}>
              {item.TaiSan}
            </td>
            <td style={{ border: "1px solid #EEE", padding: "5px" }}>
              {item.CustomerName}
              <br />
              <div>(ĐT: {item.phoneCus})</div>
            </td>
            <td
              style={{
                border: "1px solid #EEE",
                padding: "5px",
                textAlign: "right",
              }}
            >
              {formatNumber(item.Sotienvay)}
              <br />
              {item.Type !== 2 && (
                <>
                  {item.IsDuNoGiamDan == true && (
                    <span>
                      ({"Chi phí vay: " + formatMoney(item.ChiPhiVay, 2) + "%"})
                    </span>
                  )}
                  {(item.IsDuNoGiamDan == undefined ||
                    item.IsDuNoGiamDan == false) && (
                    <span>
                      (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                    </span>
                  )}
                </>
              )}
              {/* Vay họ */}
              {item.Type === 2 && (
                <>
                  {item.StatusPaidHo === 1 &&
                    "Lãi thiếu: " +
                      nFormatter(Math.ceil(item.ValueLai * item.CountTypePaid))}
                  {item.StatusPaidHo === 2 &&
                    "Lãi đủ: " + nFormatter(item.ValueLai * item.BocTrongVong)}
                  {item.StatusPaidHo === 3 &&
                    "Chi phí vay: " + formatMoney(item.ChiPhiVay, 2) + "%"}
                </>
              )}
            </td>
            <td
              style={{
                border: "1px solid #EEE",
                padding: "5px",
                textAlign: "right",
              }}
            >
              {formatNumber(item.TienLaiConNo)}
            </td>
            <td
              style={{
                border: "1px solid #EEE",
                padding: "5px",
                textAlign: "right",
              }}
            >
              {formatNumber(item.TienGocConNo)}
            </td>
            <td
              style={{
                border: "1px solid #EEE",
                padding: "5px",
                textAlign: "right",
              }}
            >
              {formatNumber(item.Value)}
            </td>
            <td style={{ border: "1px solid #EEE", padding: "5px" }}>
              {item.NgaySapNo < 0 && (
                <>
                  {item.Type === 2 && (
                    <span className="text-lai-mm">
                      Chậm {item.SoKyConNoTuTruocToiNay} Kỳ góp (
                      {item.NgayNoLaiFist} Ngày).
                    </span>
                  )}
                  {item.Type !== 2 && (
                    <span className="text-lai-mm">
                      Chậm {item.SoKyConNoTuTruocToiNay} Kỳ lãi (
                      {item.NgayNoLaiFist} Ngày).
                    </span>
                  )}
                </>
              )}
              {item.NgaySapNo === 0 && (
                <>
                  <span className="text-lai-mm">Đến hạn đóng lãi</span>
                </>
              )}
              {item.NgaySapNo > 0 && (
                <>
                  <span className="text-lai-mm">
                    {item.NgaySapNo} ngày sau đến hạn
                  </span>
                </>
              )}
            </td>
            {this.props.dataPrint.NoPhaiThuInGhiChu != undefined &&
              this.props.dataPrint.NoPhaiThuInGhiChu == 1 && (
                <td style={{ border: "1px solid #EEE", padding: "5px" }}></td>
              )}
          </tr>
        );
      });
    }
  }

  render() {
    return (
      <>
        <div id={this.props.dataPrint.TypeName}>
          {/* <table style={{ width: "90%", margin: "0 auto" }} > */}
          {/* <tr>
                            <td style={{ textAlign: "center", width: "100%", fontWeight: "bold", fontSize: "18px", color: "#000000" }}>
                                DANH SÁCH NỢ PHẢI THU
                            </td>
                        </tr> */}
          {/* <tr>
                            <td style={{ width: "100%" }}> */}
          <table style={{ width: "90%", margin: "0 auto" }}>
            <tr>
              <td
                style={{
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                  fontSize: "18px",
                  color: "#000000",
                  padding: "10px",
                }}
              >
                {" "}
                DANH SÁCH NỢ PHẢI THU
              </td>
            </tr>
          </table>
          <table
            style={{
              border: "1px solid #EEE",
              width: "100%",
              color: "#000000",
            }}
          >
            <tr>
              <th
                style={{
                  border: "1px solid #EEE",
                  padding: "5px",
                  textAlign: "center",
                }}
              >
                <div>STT</div>
                <span>[ {this.props.dataPrint.TongBanGhi} ]</span>
              </th>
              <th style={{ border: "1px solid #EEE", padding: "5px" }}>
                Mã hợp đồng
              </th>
              <th style={{ border: "1px solid #EEE", padding: "5px" }}>
                TS thế chấp
              </th>
              <th style={{ border: "1px solid #EEE", padding: "5px" }}>
                Tên khách hàng
              </th>
              <th
                style={{
                  border: "1px solid #EEE",
                  padding: "5px",
                  textAlign: "right",
                }}
              >
                Số tiền vay
                <br />
                <span>{this.props.dataPrint.TongTienVay}</span>
              </th>
              <th
                style={{
                  border: "1px solid #EEE",
                  padding: "5px",
                  textAlign: "right",
                }}
              >
                Nợ lãi
                <br />
                <span>{this.props.dataPrint.TongNolai}</span>
              </th>
              <th
                style={{
                  border: "1px solid #EEE",
                  padding: "5px",
                  textAlign: "right",
                }}
              >
                Nợ gốc
                <br />
                <span>{this.props.dataPrint.TongNoGoc}</span>
              </th>
              <th
                style={{
                  border: "1px solid #EEE",
                  padding: "5px",
                  textAlign: "right",
                }}
              >
                Tổng nợ
                <br />
                <span>{this.props.dataPrint.TongNo}</span>
              </th>
              <th
                style={{
                  border: "1px solid #EEE",
                  padding: "5px",
                  width: "120px",
                }}
              >
                Lý do
              </th>
              {this.props.dataPrint.NoPhaiThuInGhiChu != undefined &&
                this.props.dataPrint.NoPhaiThuInGhiChu == 1 && (
                  <th
                    style={{
                      border: "1px solid #EEE",
                      padding: "5px",
                      width: "120px",
                    }}
                  >
                    Ghi chú
                  </th>
                )}
            </tr>
            {this.renderTableData()}
          </table>

          {/* </td>
                        </tr >
                    </table> */}
        </div>
      </>
    );
  }
}
export default ThuChiHopDongPrint;
